import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { QueryEventHdrModel } from '../../../../../../models/aggregates/erp/dynamic-report/dynamic-report-query-event-hdr.model';
import {ApiVisa, BasicApiResponseModel} from '../../shared';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class QueriesEventHdrService extends BaseApiTemplateService<QueryEventHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    'bi-reports/query-event-hdrs/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-event-hdrs/backoffice-ep';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-event-hdrs/backoffice-ep';
    this.httpClient = theHttp;
  }

  createEvents(dtoObject: QueryEventHdrModel, visa: ApiVisa): Observable<BasicApiResponseModel<QueryEventHdrModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    'bi-reports/query-event-hdrs/processors/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        'bi-reports/query-event-hdrs/processors/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<QueryEventHdrModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa));
  }

  updateEvents(dtoObject: QueryEventHdrModel, visa: ApiVisa): Observable<BasicApiResponseModel<QueryEventHdrModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-event-hdrs/processors/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        'bi-reports/query-event-hdrs/processors/backoffice-ep';
    }
    return this.httpClient.put<BasicApiResponseModel<QueryEventHdrModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa));
  }
}
